module.exports = __webpack_public_path__ + "static/forest-0e3f53a272b5a0a63bbdbe4cb1cee458.png";